<!-- 评论页 -->
<template>
  <div class="comment-page business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>

    <div class="comment-main">
      <el-card class="box-card">
        <div class="comment-header">
          <div class="order-num">
            <div>订单号：{{Osn}}</div>
            <div>创建时间：{{CreateTime}}</div>
          </div>
          <div class="order-star" v-if="type==1">
            <div class="star-item">
              <span>物流星级：</span>
              <star @getStore="getStore" :flag="{from:1}"></star>
            </div>
            <div class="star-item">
              <span>服务星级：</span>
              <star @getStore="getStore" :flag="{from:2}"></star>
            </div>
          </div>
        </div>
      </el-card>

      <div style="margin-top: 20px">
        <el-card
          :key="index"
          class="box-card goods-item-ctn"
          v-for="(item,index) in subData.detailList"
        >
          <div class="goods-ctn">
            <div class="goods-item">
              <div class="goods-dir">
                <div class="image-ctn">
                  <img :src="downloadUrl + item.ShowImg" alt />
                </div>
                <div class="qp-name" :title="item.Name">{{item.Name}}</div>
              </div>
              <div class>
                <div class="goods-store">
                  <span>商品评价：</span>
                  <star
                    @getStore="getStore"
                    :flag="{from:3,index:index}"
                    :store="item.GoodsStar"
                    :canChange="type==1?true:false"
                  ></star>
                </div>
                <div class="text-area-ctn">
                  <span>评价晒单：</span>
                  <el-input
                    class="el-text-area"
                    type="textarea"
                    placeholder="宝贝满足你的期待吗？说说你的使用心得，分享给想买的他们吧，还可以获得积分哟"
                    v-model="item.message"
                    maxlength="100"
                    show-word-limit
                    resize="none"
                    rows="3"
                  ></el-input>
                </div>
                <div class="upload-ctn">
                  <div
                    :key="imgIdx"
                    class="preview-ctn"
                    v-for="(imgItem,imgIdx) in item.commentPictureList"
                  >
                    <img :src="imgItem" alt class="preview-img" />
                    <img
                      src="../../../assets/images/cha.png"
                      class="close-btn"
                      @click="delImage(index,imgIdx)"
                    />
                  </div>
                  <div class="upload-btn">
                    +
                    <input type="file" @change="uploadImg($event,index)" multiple />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <div style="text-align: right">
        <el-button class="buy-btn btn-primary" @click="submitData">{{type == 1 ?'提交评论':'追加评论'}}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import star from "@/components/common/star";
import uploadFile from "../../../assets/js/uploadFileMultiple";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    star,
    breadcrumb
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      type: 1,
      commentIndex: 0,
      dialogImageUrl: "",
      dialogVisible: false,
      downloadUrl: this.$util.QN_URL_BASE,
      CreateTime: "",
      Osn: "",
      searchData: {
        UserId: userMsg.EmployeeId,
        OrderId: ""
      },
      subData: {
        OrderId: "",
        UserId: userMsg.EmployeeId,
        transportStar: 0,
        serviceStar: 0,
        detailList: []
      },
      userMsg:userMsg
    };
  },
  mounted() {
    this.type = this.$route.query.type;
    this.searchData.OrderId = this.$route.query.OrderId;
    this.subData.OrderId = this.$route.query.OrderId;
    this.getData();
  },
  methods: {
    submitData() {
      if (!this.verify()) {
        return;
      }
      let url =
        this.type == 1
          ? "/api/MallSaleOrder/AddSaleOrderComment"
          : "/api/MallSaleOrder/AppendSaleOrderComment";
      this.$util
        .axiosPost({
          url: url,
          data: this.subData
        })
        .then(res => {
          this.$util.successMsg(this.type == 1 ? "评论成功" : "追加评论成功");
          setTimeout(() => {
            window.history.back(-1);
          }, 1000);
        })
        .catch(() => {});
    },
    verify() {
      let _detailList = this.subData.detailList;
      // 评论
      if (this.type == 1) {
        if (this.subData.transportStar == 0 || this.subData.serviceStar == 0) {
          this.$util.warningMsg("评分不能为空");
          return false;
        }
      }
      // 追评
      else {
        //
      }
      for (let i = 0; i < _detailList.length; i++) {
        if (_detailList[i].message == "" || _detailList[i].goodsStar == "") {
          this.$util.warningMsg("商品评分不能为空");
          return false;
        }
      }
      return true;
    },
    delImage(index, idx) {
      this.subData.detailList[index].commentPictureList.splice(idx, 1);
    },
    uploadImg($event, index) {
      let that = this;
      if (that.subData.detailList.length > 9) {
        that.$util.warningMsg("最多只能上传九张图片");
      }
      uploadFile({
        files: $event.target.files, // 上传按钮id
        url: this.$util.BASE_URL + "/UploadFile/UploadMultiple",
        type: "jpg,png,jpeg,gif",
        maxSize: 20 * 1024,
        progressCtn: "",
        nameMaxLen: 80,
        token:that.userMsg.Token,
        data: {
          key: "Commentary",
          isPrivate: false
        },
        success: function(response) {
          let res = JSON.parse(response);
          for (let i = 0; i < res.length; i++) {
            that.subData.detailList[index].commentPictureList.push(
              that.downloadUrl + JSON.parse(res[i]).fileUrl
            );
          }
        }
      });
    },
    getStore(store, data) {
      if (data.from == 1) {
        this.subData.transportStar = store;
      } else if (data.from == 2) {
        this.subData.serviceStar = store;
      } else if (data.from == 3) {
        this.subData.detailList[data.index].GoodsStar = store;
      }
    },
    getData() {
      this.$util
        .axiosGet({
          url: "/api/MallSaleOrder/GetSaleOrderDetailList",
          data: this.searchData
        })
        .then(res => {
          let _data = res.data.DetailList;
          for (let i = 0; i < _data.length; i++) {
            _data[i].commentPictureList = [];
            _data[i].message = "";
          }
          this.subData.detailList = _data;
          this.CreateTime = res.data.CreateTime;
          this.Osn = res.data.Osn;
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scoped>
.qp-name {
  width: 300px;
}
.close-btn {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
.upload-ctn {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0 0 90px;
}
.preview-ctn {
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed @border1Color;
  border-radius: 5px;
  overflow: hidden;
  .preview-img {
    max-width: 100px;
    max-height: 100px;
  }
}
.goods-item-ctn {
  margin-bottom: 10px;
}
.upload-btn {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed @border1Color;
  display: flex;
  align-items: center;
  justify-content: center;
  color: @border1Color;
  font-size: @font-lg;
  border-radius: 6px;
  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100px;
    height: 100px;
    z-index: 1;
    opacity: 0;
  }
}
.input-num {
  text-align: right;
  color: @border1Color;
}
.el-text-area {
  width: 520px;
}
.text-area-ctn {
  margin-top: 10px;
  padding: 0 20px;
  display: flex;
  span {
    flex-shrink: 0;
  }
}
.goods-store {
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.goods-item {
  display: flex;
}
.image-ctn {
  width: 100px;
  height: 100px;
  img {
    max-width: 100px;
    max-height: 100px;
  }
}
.goods-dir {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 350px;
  text-align: center;
  border-right: 1px solid @border1Color;
}
.goods-ctn {
  padding: 10px;
}
.star-item {
  padding-right: 20px;
  display: flex;
  align-items: center;
}
.comment-header {
  display: flex;
  align-items: center;
  padding: 10px;
  height: 100px;
}
.comment-main {
  width: 1000px;
  margin: 0 auto;
}
.order-num {
  width: 350px;
  font-size: @font-sm;
  line-height: 1.5em;
  padding: 0 20px;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px solid @border1Color;
}
.order-star {
  display: flex;
  align-items: center;
  font-size: @font-sm;
  padding: 0 20px;
}
</style>
